import {
   EmergencyNotificationActiveQuery,
   EmergencyNotificationTriggeredEvent,
} from '@dreryk/egabinet-emergency-notification-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import { useCqrsEvent, useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { useBoolean } from '@dreryk/react-common';

import { isEmpty } from '~libs.typescript';

import { EmergencyNotificationAlertModal } from './EmergencyNotificationAlertModal';
import { EmergencyNotificationAlert } from './types';

export const EmergencyNotificationAlertEventListener = (): JSX.Element | null => {
   const [{ setTrue: openModal, setFalse: closeModal }, showModal] = useBoolean(true);
   const {
      data: emergencyNotifications,
      refetch: refetchEmergencyNotifications,
   } = useCqrsSearch<EmergencyNotificationAlert>(
      () => {
         return new EmergencyNotificationActiveQuery();
      },
      paginations.all(),
      {
         enabled: !isDemo(),
         onSuccess: (emergencyNotifications) => {
            if (!isEmpty(emergencyNotifications)) {
               openModal();
            }
         },
      }
   );

   useCqrsEvent<EmergencyNotificationTriggeredEvent>(
      'egabinet-emergency-notification-frontend-api:EmergencyNotificationTriggeredEvent',
      refetchEmergencyNotifications
   );

   if (!showModal || isEmpty(emergencyNotifications)) {
      return null;
   }

   return <EmergencyNotificationAlertModal onClose={closeModal} emergencyNotifications={emergencyNotifications} />;
};
